<template>
  <div>
    <main class="main">
      <div
        class="page-header text-center"
        style="background-image: url('/img/wallpaperbetter.jpg')"
      >
        <div class="container">
          <h1 class="page-title">Il tuo account<span>Vascularclass</span></h1>
        </div>
        <!-- End .container -->
      </div>
      <!-- End .page-header -->
      <nav aria-label="breadcrumb" class="breadcrumb-nav mb-3 bg-light">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/dashboard">Home</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Il tuo profilo
            </li>
          </ol>
        </div>
        <!-- End .container -->
      </nav>
      <LoadedComponent :loading="loading" />

      <div class="dashboard" v-if="loading == false">
        <div class="container">
          <AlertComponent
            :alert-type="'success'"
            :message="successMessage"
          ></AlertComponent>
          <div class="row">
            <aside class="col-md-4 col-lg-3 p-4">
              <div class="card bg-light pl-4 pr-4 pb-1 pt-1">
                <ul
                  class="nav nav-dashboard flex-column mb-3 mb-md-0"
                  role="tablist"
                >
                  <li class="nav-item">
                    <a
                      class="nav-link active"
                      id="tab-dashboard-link"
                      data-toggle="tab"
                      href="#tab-dashboard"
                      role="tab"
                      aria-controls="tab-dashboard"
                      aria-selected="true"
                      >I tuoi dati</a
                    >
                  </li>

                  <li class="nav-item">
                    <a
                      class="nav-link"
                      id="tab-subpatologies-link"
                      data-toggle="tab"
                      href="#tab-subpatologies"
                      role="tab"
                      aria-controls="tab-subpatologies"
                      aria-selected="true"
                      >Trattamenti</a
                    >
                  </li>

                  <li class="nav-item">
                    <a
                      class="nav-link"
                      id="tab-groups-link"
                      data-toggle="tab"
                      href="#tab-groups"
                      role="tab"
                      aria-controls="tab-groups"
                      aria-selected="true"
                      >I tuoi gruppi</a
                    >
                  </li>

                  <li class="nav-item">
                    <a class="nav-link" href="#" @click="logout"> Sign Out</a>
                  </li>
                </ul>
              </div>
            </aside>
            <!-- End .col-lg-3 -->

            <div class="col-md-8 col-lg-9">
              <div class="tab-content">
                <div
                  class="tab-pane fade show active"
                  id="tab-dashboard"
                  role="tabpanel"
                  aria-labelledby="tab-dashboard-link"
                >
                  <div class="card bg-light pl-4 pr-4 pt-2 pb-2">
                    <form method="POST" @submit.prevent="update_profile">
                      <div class="row">
                        <div class="col-md-6 mb-2">
                          <img
                            :src="user.photo"
                            alt=""
                            class="img-thumbnail"
                            style="max-width: 180px"
                          />
                        </div>
                        <div class="col-md-6 mb-2 d-flex align-items-center">
                          <div class="input-group mb-3">
                            <div class="custom-file">
                              <input
                                type="file"
                                class="custom-file-input"
                                name="link_2"
                                @change="handleFileUpload"
                                id="link_2"
                                aria-describedby="inputGroupFileAddon01"
                              />
                              <label
                                class="custom-file-label text-center"
                                for="link_2"
                                id="labelsfiles"
                                >{{ nameFiles }}</label
                              >
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <label>Nome *</label>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Inserisci il tuo nome"
                            v-model="form.name"
                          />
                          <div class="alert alert-danger" v-if="errors.name">
                            {{ errors.name[0] }}
                          </div>
                        </div>
                        <!-- End .col-sm-6 -->

                        <div class="col-sm-6">
                          <label>Cognome *</label>
                          <input
                            type="text"
                            class="form-control"
                            name="cognome"
                            v-model="form.lastname"
                            placeholder="Inserisci il tuo cognome"
                          />
                          <div
                            class="alert alert-danger"
                            v-if="errors.lastname"
                          >
                            {{ errors.lastname[0] }}
                          </div>
                        </div>
                        <!-- End .col-sm-6 -->
                      </div>
                      <!-- End .row -->

                      <label>Email *</label>
                      <input
                        type="email"
                        class="form-control"
                        v-model="form.email"
                        placeholder="Inserisci la email"
                      />
                      <div class="alert alert-danger" v-if="errors.email">
                        {{ errors.email[0] }}
                      </div>

                      <label>Cellulare </label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span
                            class="input-group-text"
                            id="basic-addon1"
                            style="height: 40px"
                            >{{ prefix }}</span
                          >
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          v-model="phone"
                          placeholder="Inserisci il prefisso se estero"
                        />
                      </div>
                      <div class="alert alert-danger" v-if="errors.phone">
                        {{ errors.phone[0] }}
                      </div>

                      <label>Ospedale</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.hospital"
                        placeholder="Inserisci il tuo ospedale"
                      />
                      <div class="alert alert-danger" v-if="errors.hospital">
                        {{ errors.hospital[0] }}
                      </div>

                      <label>Specializzazione</label>
                      <select
                        class="form-control"
                        v-model="form.specialisation_id"
                      >
                        <option
                          v-for="specialisation in specialisations"
                          :key="specialisation.id"
                          :value="specialisation.id"
                        >
                          {{ specialisation.name }}
                        </option>
                      </select>
                      <div
                        class="alert alert-danger"
                        v-if="errors.specialisation_id"
                      >
                        {{ errors.specialisation_id[0] }}
                      </div>

                      <label>Qualifica</label>
                      <select
                        class="form-control"
                        v-model="form.qualification_id"
                      >
                        <option
                          v-for="qualification in qualifications"
                          :key="qualification.id"
                          :value="qualification.id"
                        >
                          {{ qualification.name }}
                        </option>
                      </select>
                      <div
                        class="alert alert-danger"
                        v-if="errors.qualification_id"
                      >
                        {{ errors.qualification_id[0] }}
                      </div>

                      <label>Nuova password</label>
                      <input
                        type="password"
                        name="password"
                        class="form-control"
                        placeholder="Scrivi la nuova password"
                        v-model="form.password"
                      />
                      <div class="alert alert-danger" v-if="errors.password">
                        {{ errors.password[0] }}
                      </div>

                      <label>Conferma nuova password</label>
                      <input
                        type="password"
                        name="password_confirmation"
                        class="form-control"
                        placeholder="Conferma la password"
                        v-model="form.password_confirmation"
                      />
                      <div class="text-right pt-2">
                        <button type="submit" class="btn btn-outline-primary-2">
                          <span>Salva i cambiamenti</span>
                          <i class="icon-long-arrow-right"></i>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>

                <div
                  class="tab-pane"
                  id="tab-subpatologies"
                  role="tabpanel"
                  aria-labelledby="tab-subpatologies-link"
                >
                  <div class="card bg-light pl-4 pr-4 pt-2 pb-2">
                    <p><strong> Le tue preferenze </strong></p>
                    <div class="row mb-lg-4">
                      <div
                        class="col-12 col-sm-6 col-xl-6 align-items-stretch flex-column mb-2"
                        v-for="patology in user.patologies"
                        :key="patology.id"
                      >
                        <div class="card shadow-sm d-flex flex-fill">
                          <div class="card-body">
                            <div class="float-left mr-3 text-center">
                              <div style="max-width: 160px; max-height: 1000px">
                                <img
                                  src="patologia.jpg"
                                  alt="Foto copertina "
                                />
                              </div>
                            </div>
                            <h4 class="mb-0 text-uppercase">
                              {{ patology.name }}
                            </h4>

                            <p class="text-muted" v-if="patology.description">
                              {{ patology.description }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <form @submit.prevent="request_patologies">
                      <p>
                        <strong>
                          Vuoi modificare le tue preferenze per i trattamenti?
                        </strong>
                      </p>
                      <div class="row">
                        <div
                          v-for="patology in patologies"
                          :key="patology.id"
                          class="col-md-2"
                        >
                          <!-- Categoria con icona per aprire/chiudere -->
                          <div class="mb-1">
                            <input
                              type="checkbox"
                              v-model="requestpatologies.patologies"
                              :value="patology.id"
                              :checked="
                                requestpatologies.patologies.includes(
                                  patology.id
                                )
                              "
                            />
                            {{ patology.name }}
                          </div>
                        </div>
                      </div>
                      <div class="text-right">
                        <button type="submit" class="btn btn-info">
                          INVIA LA RICHIESTA DI AGGIORNAMENTO
                        </button>
                      </div>
                    </form>
                  </div>
                </div>

                <div
                  class="tab-pane"
                  id="tab-groups"
                  role="tabpanel"
                  aria-labelledby="tab-groups-link"
                >
                  <div class="card bg-light pl-4 pr-4 pt-2 pb-2">
                    <div class="text-right">
                      <button
                        type="button"
                        class="btn btn-primary text-uppercase"
                        data-toggle="modal"
                        data-target="new-group"
                        @click="new_group_modal"
                      >
                        Crea il tuo gruppo
                        <i
                          class="las la-plus-square"
                          style="font-size: 25px"
                        ></i>
                      </button>
                    </div>
                    <div class="row mb-lg-4">
                      <div
                        class="col-12 col-sm-6 col-xl-6 align-items-stretch flex-column mt-2"
                        v-for="(group, index) in user.groups"
                        :key="group.id"
                      >
                        <div class="card shadow-sm d-flex flex-fill">
                          <div class="card-body">
                            <div class="float-left mr-3 text-center">
                              <div style="max-width: 160px; max-height: 1000px">
                                <img src="rioniune.jpg" alt="Foto copertina " />
                              </div>
                            </div>
                            <div style="min-height: 110px">
                              <h4 class="mb-0">{{ group.name }}</h4>
                              <p>
                                {{ group.description }}
                              </p>
                            </div>

                            <p class="text-muted text-left">
                              <span
                                class="small badge rounded-pill badge-light p-2 border"
                                style="font-size: 14px"
                              >
                                <i class="las la-calendar-alt"></i
                              ></span>
                              Creato: {{ group.created_at }}
                            </p>
                            <p class="text-muted text-left">
                              <span
                                class="small badge rounded-pill badge-light p-2 border"
                                style="font-size: 14px"
                              >
                                <i class="las la-envelope-open"></i
                              ></span>
                              Creato da: {{ group.owner_email }}
                            </p>

                            <p class="text-muted text-left">
                              <span
                                class="small badge rounded-pill badge-light p-2 border"
                                style="font-size: 14px"
                              >
                                <i class="las la-users"></i
                              ></span>
                              Numero di utenti: {{ group.count }}
                            </p>
                            <div class="text-center">
                              <span
                                class="small badge rounded-pill badge-info p-2 border"
                                :id="'show_users_groups_' + index"
                                style="font-size: 14px"
                                @click="show_list(index)"
                              >
                                <i
                                  :class="
                                    group.show_users &&
                                    group.show_users === true
                                      ? 'las la-angle-double-up'
                                      : 'las la-angle-double-down'
                                  "
                                ></i>
                              </span>

                              <ul
                                class="list-group mt-3"
                                v-show="
                                  group.show_users && group.show_users === true
                                "
                              >
                                <li
                                  class="list-group-item d-flex justify-content-between align-items-center"
                                  v-for="user in group.users"
                                  :key="user.id"
                                >
                                  <div class="d-flex align-items-center">
                                    <div v-if="user.photo">
                                      <img
                                        :src="user.photo"
                                        class="mr-1 user-img"
                                        alt="User Image"
                                      />
                                    </div>
                                    <div
                                      v-else
                                      class="mr-1"
                                      style="width: 50px"
                                    >
                                      <i
                                        class="las la-user"
                                        style="font-size: 50px"
                                      ></i>
                                    </div>
                                    <div>
                                      <h5 class="mb-0 text-uppercase">
                                        {{ user.name + " " + user.lastname }}
                                      </h5>
                                      <small>{{ user.email }}</small>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End .col-lg-9 -->
            </div>
            <!-- End .row -->
          </div>
          <!-- End .container -->
        </div>
        <!-- End .dashboard -->
        <div
          class="modal fade"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          id="new-group"
        >
          <div
            class="modal-dialog modal-xl"
            role="document"
            style="max-width: 90%"
          >
            <div class="modal-content">
              <div class="modal-header">
                <div class="w-100">
                  <h5 class="modal-title text-center">
                    Seleziona gli utenti o i gruppi
                  </h5>
                </div>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="close-modal-delete-news"
                >
                  <span aria-hidden="true"><i class="icon-close"></i></span>
                </button>
              </div>
              <div class="modal-body p-4">
                <div class="w-100 text-center">
                  <form class="needs-validation" @submit.prevent="create_group">
                    <div class="col-md-12 mb-3">
                      <label for="name_group"
                        >Nome del gruppo
                        <span class="text-danger">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="name_group"
                        placeholder="Scrivi il nome del gruppo"
                        v-model="formGroups.name"
                      />
                      <div
                        class="bg-info text-danger p-2"
                        v-if="errors_group.name"
                      >
                        {{ errors_group.name[0] }}
                      </div>
                    </div>

                    <div class="col-md-12 mb-3">
                      <label for="name_group">Descrizione</label>
                      <textarea
                        class="form-control"
                        id="name_group"
                        placeholder="Scrivi una descrizione"
                        rows="3"
                        v-model="formGroups.description"
                      ></textarea>

                      <div
                        class="bg-info text-danger p-2"
                        v-if="errors_group.description"
                      >
                        {{ errors_group.description[0] }}
                      </div>
                    </div>

                    <div class="col-md-12">
                      <h6 class="text-center">Seleziona gli utenti</h6>
                      <div
                        class="bg-info text-danger p-2"
                        v-if="errors_group.users"
                      >
                        {{ errors_group.users[0] }}
                      </div>
                      <div class="row">
                        <div
                          class="col-md-3"
                          v-for="user in users"
                          :key="user.id"
                        >
                          <ul>
                            <li>
                              <div class="icheck-wetasphalt mt-3">
                                <input
                                  type="checkbox"
                                  :id="'chb1-' + user.id"
                                  v-model="formGroups.users"
                                  :value="user.id"
                                />
                                <label :for="'chb1-' + user.id">{{
                                  user.full_name
                                }}</label>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="w-100 text-right">
                        <button type="submit" class="btn btn-primary">
                          Salva il gruppo
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- End .page-content -->
    </main>
  </div>
  <!-- End .main -->
</template>
<script>
import httpauth from "@/services/httpauth.js";
import $ from "jquery";
import { useAuth } from "@/stores/auth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import AlertComponent from "@/components/AlertComponent.vue";
import httpservices from "@/services/httpservices.js";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import http from "@/services/http.js";
window.jQuery = $;
window.$ = $;
export default {
  name: "ProfilePage",
  components: {
    LoadedComponent,
    AlertComponent,
  },
  data() {
    return {
      user: {},
      errors: [],
      loading: true,
      prefix: "",
      phone: "",
      form: {
        name: "",
        lastname: "",
        email: "",
        photo: null,
        password: "",
        phone: "",
        password_confirmation: "",
        qualification_id: "",
        specialisation_id: "",
        hospital: "",
      },
      formGroups: {
        name: "",
        description: "",
        users: [],
      },
      requestpatologies: {
        patologies: [],
      },
      patologies: [],
      errors_group: [],
      successMessage: "",
      qualifications: [],
      specialisations: [],
      nameFiles: "Scegli una foto",
      selectedFile: null,
      users: [],
      errors_request: [],
    };
  },
  mounted() {
    this.qualificationsData();
    this.specialisationsData();
    this.loadUser();
    this.fetchUsers();
    this.fetchPatology();
  },
  methods: {
    async loadUser() {
      await httpauth
        .get("/profile")
        .then((response) => {
          this.user = response.data.data;
          this.loading = false;
          this.requestpatologies.patologies = this.user.patologies.map(
            (patology) => patology.id
          );
          const countryCodeLength = this.user.phone.length - 10;
          this.prefix = this.user.phone.substr(0, countryCodeLength);
          console.log(this.prefix);
          this.phone = this.user.phone.substr(
            countryCodeLength,
            this.user.phone.length
          );
          this.form = {
            name: this.user.name,
            lastname: this.user.lastname,
            email: this.user.email,
            photo: null,
            password: "",
            password_confirmation: "",
            qualification_id: this.user.qualification_id,
            phone: this.user.phone,
            specialisation_id: this.user.specialisation_id,
            hospital: this.user.hospital,
          };
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          ) {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async request_patologies() {
      this.errors_request = [];
      this.loading = true;
      await httpauth
        .post("/request-patologies", this.requestpatologies)
        .then((response) => {
          this.loading = false;
          const $toast = useToast();

          $toast.open({
            message: response.data.message,
            type: response.data.status == true ? "info" : "warning",
            position: "top-right",
            // all of other options may go here
          });
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.data.errors) {
            this.errors_request = error.response.data.message;
          }
        });
    },
    async fetchPatology() {
      await httpservices
        .getPatology()
        .then((response) => {
          this.patologies = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchUsers() {
      await httpservices
        .getUsers()
        .then((response) => {
          this.users = this.users = response.data.data;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          ) {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async qualificationsData() {
      var { data } = await http.get("/qualifications");
      this.qualifications = data.data;
    },
    async create_group() {
      await httpauth
        .post("/groups", this.formGroups)
        .then((response) => {
          if (response.data.status) {
            this.loadUser();
            const $toast = useToast();
            $toast.open({
              message: response.data.message,
              type: "success",
              position: "top-right",
            });
            this.formGroups.name = "";
            this.formGroups.description = "";
            this.formGroups.users = [];
            $("#new-group").modal("hide");
          }
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          ) {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          } else if (error.response.data.errors) {
            this.errors_group = error.response.data.errors;
            console.log(this.errors_group);
          }
        });
    },
    show_list(index) {
      if (
        (this.user.groups[index].show_users =
          this.user.groups[index].show_users &&
          this.user.groups[index].show_users == true)
      ) {
        this.user.groups[index].show_users = false;
      } else {
        this.user.groups[index].show_users = true;
      }
    },
    new_group_modal() {
      $("#new-group").modal("show");
    },
    async specialisationsData() {
      var { data } = await http.get("/specialisations");
      this.specialisations = data.data;
    },
    async update_profile() {
      const formData = new FormData();

      formData.append("name", this.form.name);
      formData.append("lastname", this.form.lastname);
      formData.append("email", this.form.email);
      formData.append("photo", this.form.photo);
      formData.append("phone", this.prefix + this.phone);
      this.form.phone = this.prefix + this.phone;
      formData.append("password", this.form.password);
      formData.append("password_confirmation", this.form.password_confirmation);
      formData.append("qualification_id", this.form.qualification_id);
      formData.append("specialisation_id", this.form.specialisation_id);
      formData.append("hospital", this.form.hospital);
      await httpauth
        .post("/profile/update", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.form.photo = null;
          this.loadUser();
          this.successMessage = response.data.message;
        });
    },
    async logout() {
      httpauth
        .get("/logout")
        .then((response) => {
          if (response.data.status) {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          ) {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    handleFileUpload(event) {
      const maxSize = 1 * 1024 * 1024 * 1024;
      const files = event.target.files[0];
      const totalSize = files.size;
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (totalSize <= maxSize) {
        if (!allowedTypes.includes(files.type)) {
          alert("Per favore seleziona un file valido (JPEG/JPG/PNG).");
          this;
          return;
        }
        this.nameFiles = files.name;
        this.form.photo = files;
      } else {
        alert("La dimensione totale dei file supera 1 GB");
      }
    },
  },
};
</script>
<style scoped>
.user-img {
  max-width: 50px;
}
.square-btn {
  width: 40px !important;
  height: 40px !important;
  padding: 0 !important;
  font-size: 20px !important;
  min-width: 40px !important;
}
</style>